<template>
    <DecorationEfficiency></DecorationEfficiency>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const DecorationEfficiency = defineAsyncComponent(() =>
    import(
        "../../components/Decoration/DecorationEfficiency.vue"
    )
);
export default {
    name: "DecorationEfficiencyPage",
    components: { DecorationEfficiency, AuthLayout },
}
</script>
